import { createApp } from 'vue';
import App from './App.vue';
import AppConfig from './models/appConfig.model';
import axios from 'axios'
import VueAxios from 'vue-axios'

let appData: AppConfig;


// Convert the attributes of the given html element to an object.
// The values are transformed by applying JSON.parse
// in order to have correct types (Booleans, Numbers, Arrays, Objects, ...)
const attributesToProps = (element) => {
  const props = {appconfig : appData};
  let sectionJSON: AppConfig;
  console.log(element);
  const sectionData = element.getAttribute('data-content-config');
  if (sectionData && sectionData != null && sectionData != '') {
    sectionJSON = JSON.parse(sectionData);
    element.removeAttribute('data-content-config');
    const section = sectionJSON.sectionTitle ? sectionJSON.sectionTitle : 'Related Content';

    props.appconfig = new AppConfig(sectionJSON.cardCount, sectionJSON.cardNodes, 
      sectionJSON.topics, section, sectionJSON.excludeNews, 
      sectionJSON.initialApi, sectionJSON.loadApi, sectionJSON.excludeNode);
    //console.log(sectionData);
  }
//   const topics = element.getAttribute('data-topics');
//   if (topics && topics != null && topics.length > 0) {
//     topicJSON = JSON.parse(topics);
//     props.appconfig = new AppConfig(card, cardJSON, topicJSON, section);
    
//     element.removeAttribute('data-topics');
//   }
  return props;
};
const node = document.getElementById('cob-related-content') as Element;
const props = attributesToProps(node);
const app = createApp(App, props);
app.use(VueAxios, axios);
app.provide('axios', app.config.globalProperties.axios);
app.mount(node);
